<div class="auto-login-form-container full-height">

    <div class="flex full-width full-height justify-content-center align-items-center">
        <div class="loader loader--xl"></div>
    </div>

</div>
